var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.auth0CallBackSpinner},[_c('img',{attrs:{"src":"/static/img/loading.svg","alt":"loading"}})])}
var staticRenderFns = []

export { render, staticRenderFns }